import BasicLinkButton from "../baseLinkButton/BasicLinkButton";
import { faClone } from "@fortawesome/pro-solid-svg-icons";

interface DuplicateLinkButtonProps {
  onClick: () => void;
  isDisabled?: boolean;
  after?: React.ReactNode;
}

function DuplicateLinkButton(props: DuplicateLinkButtonProps) {
  const { onClick, isDisabled, after } = props;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <BasicLinkButton text="Duplicate" icon={faClone} onClick={onClick} isDisabled={isDisabled} />
      {after}
    </div>
  );
}

export default DuplicateLinkButton;
